<template lang="pug">
div
  audio#audio(
    :src="sourcedefault", 
    type="audio/mpeg",
    controls
  )
  .audiodefault.font-btn-color(v-if="isplay", @click="audioplay") 有聲保險 唸給你聽 
    svg-icon.i_ml_2(
      iconClass="volume-high-solid",
      className="volume-high-solid"
    )
  .audioguide.font-btn-color(v-else)
    .audiobtn(v-if="ispause", @click="audioplay")
      svg-icon.i_ml_1(
        iconClass="play-solid",
        className="play-solid"
      )
    .audiobtn.font-btn-color(v-else, @click="audiopause")
      svg-icon.i_ml_1(
        iconClass="pause-solid",
        className="pause-solid"
      )
    .audiobtn.font-btn-color(@click="audiostop")
      svg-icon.i_ml_1(
        iconClass="stop-solid",
        className="stop-solid"
      )
    .audiobtn.font-btn-color(
      @click="changeslow", 
      :class="{ active: playState == 'slow' }"
    )  慢
    .audiobtn.font-btn-color(
      @click="changedefault", 
      :class="{ active: playState == 'default' }"
    )  中
    .audiobtn.font-btn-color(
      @click="changefast", 
      :class="{ active: playState == 'fast' }"
    )  快 
    div
      img.dashboard(src="@/assets/img/icon/dashboard.png")
  
</template>

<script>
export default {
  name: "AudioGuide",
  props: {
    sourcefast: String,
    sourcedefault: String,
    sourceslow: String,
  },
  data() {
    return {
      isplay: true,
      ispause: false,
      playState: "default",
    };
  },
  methods: {
    audioplay() {
        let audio = document.getElementById("audio");
        audio.play();
        this.isplay = false;
        this.ispause = false;
    },
    audiopause() {
        let audio = document.getElementById("audio");
        audio.pause();
        this.ispause = true;
    },
    audiostop() {
        let audio = document.getElementById("audio");
        audio.currentTime = 0;
        audio.pause();
        this.isplay = true;
    },
    changefast() {
      if(this.playState == "fast") return
      let audio = document.getElementById("audio");
      audio.src = this.sourcefast;
      audio.play();
      this.playState = "fast";
      this.ispause = false;
    },
    changedefault() {
      if(this.playState == "default") return
      let audio = document.getElementById("audio");
      audio.src = this.sourcedefault;
      audio.play();
      this.playState = "default";
      this.ispause = false;
    },
    changeslow() {
      if(this.playState == "slow") return
      let audio = document.getElementById("audio");
      audio.src = this.sourceslow;
      audio.play();
      this.playState = "slow";
      this.ispause = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/audioguide";
.font-btn-color{
  color: var(--font-btn-color) !important;
}
</style>